//todo refactor

import { isMobile as is_Mobile } from 'mobile-device-detect';
import { isIOS as is_IOS } from 'mobile-device-detect';
import { isAndroid as is_Android } from 'mobile-device-detect';
import { isTablet as is_Tablet } from 'mobile-device-detect';
import { isMobileOnly, deviceDetect } from 'mobile-device-detect';
import { utils } from 'pixi.js';

export const isMobileOrTablet = is_Mobile;
export const isMobile = isMobileOnly;
export const isTablet = is_Tablet;
export const isIOS = is_IOS;
export const isAndroid = is_Android;
export const isTouch = isTouchDevice();

function isTouchDevice() {
  // works on most browsers || works on IE10 with some false positives
  return 'ontouchstart' in window || 'onmsgesturechange' in window;
}

export const getFeatures = () => {
  const detect = deviceDetect();
  detect.isTouch = isTouch;
  detect.isMobileOrTablet = isMobileOrTablet;
  detect.isMobile = isMobile;
  detect.isTablet = isTablet;
  detect.isIOS = isIOS;
  detect.isAndroid = isAndroid;
  detect.pixiIsMobile = utils.isMobile;

  return detect;
};
